import { ValueOf } from 'type-fest';

export const CardCompany = {
  신한: 'SHINHAN',
  현대: 'HYUNDAI',
  삼성: 'SAMSUNG',
  우리: 'WOORI',
  국민: 'KOOKMIN',
  롯데: 'LOTTE',
  농협: 'NONGHYEOP',
  하나: 'HANA',
  비씨: 'BC',
  산업: 'KDBBANK',
  토스뱅크: 'TOSSBANK',
  카카오뱅크: 'KAKAOBANK',
  KDB: 'KDB',
  수협: 'SUHYEOP',
  전북: 'JEONBUKBANK',
  우체국: 'POST',
  새마을: 'SAEMAUL',
  씨티: 'CITI',
  저축: 'SAVINGBANK',
  제주: 'JEJUBANK',
  광주: 'GWANGJUBANK',
  신협: 'SHINHYEOP',
  JCB: 'JCB',
  유니온페이: 'UNIONPAY',
  마스터: 'MASTER',
  비자: 'VISA',
  다이너스: 'DINERS',
  디스커버: 'DISCOVER',
} as const;

export type CardCompany = keyof typeof CardCompany;

export type CardCompanyCode = ValueOf<typeof CardCompany>;
